import { buildUriForCall } from '@/helpers/functions/buildUri'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import {fakeUrl} from "@/helpers/functions/fakeDataStats";

export default {
  namespaced: true,
  state: {
    loading: false,
    filters: {
      date_debut: null,
      date_fin: null,
      diffuseur: 'facebook',
      type: null
    },
    mode: 'reset',
    statistics: {
      facebook: {},
      instagram: {}
    }
  },
  getters: {
    getStatistics: (state) => state.statistics,
    getFilters: (state) => state.filters,
    getLoadingStats: (state) => state.loading,
    getCurrentDiffuseur: (state) => state.filters.diffuseur,
    callPosts: (state) => state.filters.type
  },
  mutations: {
    setLoadingStatistics (state, isLoad) {
      state.loading = isLoad
    },
    setStatistics (state, data) {
      state.statistics = data
    },
    setDiffuseur (state, { diffuseur }) {
      state.filters.diffuseur = diffuseur
    },
    setMode (state, mode) {
      state.mode = mode
    },
    setFilters (state, { key, value }) {
      state.filters[key] = value
    },
    setResetFilters (state, { tabName }) {
      state.filters.date_debut = null
      state.filters.date_fin = null
      state.filters.diffuseur = tabName
      state.filters.type = null
      state.mode = 'reset'
    }
  },
  actions: {
    loadStatistics ({ commit, state }) {
      commit('setLoadingStatistics', true)

      const path = fakeUrl('/social-management/statistiques', '/fake/statistics/meta')

      const uri = buildUriForCall(path, state.filters)
      return HTTP_HYPER_ESPACE_BACKEND.get(uri)
        .then((response) => {
          const results = (response.status === 200) ? response.data : []
          commit('setStatistics', results)
        })
        .catch((error) => {
          console.log(error)
          commit('setStatistics', [])
        })
        .finally(() => {
          commit('setLoadingStatistics', false)
        })
    }
  }
}
